import React from "react"
import {Box} from "@mui/material"
import LowerHeaderWrapper from "../../../components/LowerHeaderWrapper"
import BackToSiteBanner from "../../../components/BackToSiteBanner"
import CookieConsent from "../../../components/CookieConsent"
import WidescreenCookieConsent from "../../../components/WidescreenCookieConsent"
import CountryChangeConfirmPopup from "../../../components/CountryChangeConfirmPopup"
import {HeaderContainer, InnerContainer, LeftSideContainer, RightSideContainer} from "./components"
import Brand from "../../../components/Brand"
import {SearchBigScreen, SearchSmallScreen} from "../../../components/Search"
import MyAccount from "../../../components/MyAccount"
import QuickLinksContainer from "../../../components/QuickLinksContainer"
import Favourites from "../../../components/Favourites"
import ShoppingBag from "../../../components/ShoppingBag"
import Checkout from "../../../components/Checkout"
import {HEADER_NAV_BAR_QUICK_LINKS, HEADER_NAV_BAR_SHOPPING_BAG_CHECKOUT} from "../../../config/constants"
import CountryLangSelector from "../../../components/CountryLangSelector"
import TestTools from "../../../components/TestTools"
import TimeMachineDate from "../../../components/TimeMachineDate"
import UpperHeaderWrapper from "../../../components/UpperHeader"
import SaleBagWarningModal from "../../../components/SaleBagWarningModal"
import StaticHeaderBanner from "../../../components/StaticHeaderBanner"
import PrimaryNav from "../../../components/PrimaryNav"
import SecondaryNav from "../../../components/SecondaryNav"
import SecureIcon from "../../../components/SecureIcon"
import HelpLink from "../../../components/SecureHelpLink"
import SecureHeaderWrapper from "../../../components/SecureHeaderWrapper"

export interface ClubHeaderProps {
    closeModalHandler: () => void
    enableCookieConsent: boolean
    showCheckoutButton: boolean
    showModal: boolean
    showSaleWarningBag: boolean
    showStaticHeaderBanner: boolean
    displayTestTools: boolean
    textAlignment: string
    useDevEsi: boolean
    widescreenCookieConsent: boolean
    isSecure: boolean
}

export const ClubHeaderComposition = ({
    closeModalHandler,
    enableCookieConsent,
    showCheckoutButton,
    showModal,
    showSaleWarningBag,
    showStaticHeaderBanner,
    displayTestTools,
    textAlignment,
    widescreenCookieConsent,
    isSecure,
}: ClubHeaderProps) => {
    return isSecure ? (
        <header dir={textAlignment}>
            <SecureHeaderWrapper>
                <LeftSideContainer>
                    <SecureIcon />
                </LeftSideContainer>
                <Brand tabbedNavigationEnabled={false} />
                <RightSideContainer>
                    <HelpLink />
                    <ShoppingBag isSecure />
                    <CountryLangSelector isOpeningFromBottom />
                </RightSideContainer>
                {enableCookieConsent && (widescreenCookieConsent ? <WidescreenCookieConsent /> : <CookieConsent />)}
            </SecureHeaderWrapper>
        </header>
    ) : (
        <HeaderContainer dir={textAlignment}>
            <BackToSiteBanner />
            <UpperHeaderWrapper>
                {showStaticHeaderBanner && <StaticHeaderBanner />}
                <InnerContainer>
                    <LeftSideContainer>
                        <SearchSmallScreen />
                        <SearchBigScreen />
                        <Box component="div" sx={{display: {md: "none", xs: "block"}}}>
                            <Favourites anchorStyles={{display: {xs: "flex"}}} />
                        </Box>
                    </LeftSideContainer>
                    <Brand tabbedNavigationEnabled={false} />
                    <RightSideContainer>
                        <QuickLinksContainer containerStyles={{display: {md: "block", xs: "none"}}} />
                        <Box component="div" sx={{display: {md: "block", xs: "none"}}}>
                            <Favourites anchorStyles={{display: {xs: "flex"}}} />
                        </Box>
                        <MyAccount tooltipPlacement="bottom-end" tooltipEnableModArrow />
                        <ShoppingBag
                            tooltipModifiers={[
                                {
                                    name: "offset",
                                    options: {
                                        enabled: true,
                                        offset: [-125, 7],
                                    },
                                },
                            ]}
                        />
                        {showCheckoutButton && (
                            <Checkout
                                dataGaV1={HEADER_NAV_BAR_QUICK_LINKS}
                                dataGaV2={HEADER_NAV_BAR_SHOPPING_BAG_CHECKOUT}
                            />
                        )}
                        <CountryLangSelector isOpeningFromBottom />
                        {displayTestTools && <TestTools />}
                        <TimeMachineDate />
                        {showSaleWarningBag && <SaleBagWarningModal />}
                    </RightSideContainer>
                </InnerContainer>
            </UpperHeaderWrapper>
            <LowerHeaderWrapper>
                <PrimaryNav />
                <SecondaryNav />
            </LowerHeaderWrapper>
            {showModal && <CountryChangeConfirmPopup showModal={showModal} closeModal={closeModalHandler} />}
            {enableCookieConsent && (widescreenCookieConsent ? <WidescreenCookieConsent /> : <CookieConsent />)}
        </HeaderContainer>
    )
}
export default ClubHeaderComposition
